import React from 'react';
import BaseCellRenderer from './BaseCellRenderer';
import {
    BudgetProposalResourceMetadataT,
    InscriptionWithMetadata,
    ChapterT,
} from 'routes/BudgetModule/config/types';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { NO_CHAPTER } from 'routes/BudgetModule/config/constants';

type ChapterCellRendererProps = {
    data: InscriptionWithMetadata;
    value: ChapterT['softwareId'] | null;
    setValue: (val: ChapterT['softwareId'] | null) => void;
    trackingInformation?: {
        eventName: string;
        metadata?: BudgetProposalResourceMetadataT;
    };
    queryCacheKey: InscriptionQueryKey;
    chapters?: ChapterT[];
};

export default function ChapterCellRenderer({
    data,
    value,
    setValue,
    trackingInformation,
    queryCacheKey,
    chapters = [],
}: ChapterCellRendererProps): React.ReactElement {
    const nullValue: ChapterT = {
        code: NO_CHAPTER,
        label: NO_CHAPTER,
        softwareId: '',
    };

    return (
        <BaseCellRenderer<ChapterT, ChapterT['softwareId'] | null>
            data={data}
            value={value}
            setValue={setValue}
            trackingInformation={trackingInformation}
            queryCacheKey={queryCacheKey}
            options={chapters}
            noValue={nullValue}
            optionLabelKey="code"
            optionValueKey="softwareId"
            updateFieldKey="chapter.softwareId"
        />
    );
}
